/* ============================================================
   TCG Easter Eggs
   - Código Konami (↑↑↓↓←→←→BA) → flash holográfico + confetti + toast
   - Mascota interactiva ([data-tcg-mascot]): reacción al click/tap;
     7 toques en 10 s disparan el mismo secreto (camino móvil)
   - Config en window.tcgEggs (la inyecta theme.liquid):
     { enabled, mascot, code, message }
   - El visual respeta prefers-reduced-motion y el toggle tcg-fx-off;
     el toast se muestra siempre.
   ============================================================ */
(function () {
  'use strict';

  var cfg = window.tcgEggs || {};
  if (!cfg.enabled && !cfg.mascot) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEQ = ['arrowup', 'arrowup', 'arrowdown', 'arrowdown', 'arrowleft', 'arrowright', 'arrowleft', 'arrowright', 'b', 'a'];
  var buffer = [];
  var armed = true;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fxOff() {
    return document.documentElement.classList.contains('tcg-fx-off');
  }

  function copyText(text, btn) {
    function done() {
      var prev = btn.textContent;
      btn.textContent = '¡Copiado!';
      setTimeout(function () { btn.textContent = prev; }, 1800);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, fallback);
    } else { fallback(); }
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(ta);
    }
  }

  function confetti() {
    if (reduceMotion || fxOff()) return;
    var rain = document.createElement('div');
    rain.className = 'tcg-egg-rain';
    rain.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 20; i++) {
      var piece = document.createElement('div');
      piece.className = 'tcg-egg-confetti';
      piece.style.left = (Math.random() * 100) + 'vw';
      piece.style.animationDelay = (Math.random() * 0.9) + 's';
      piece.style.setProperty('--rz', Math.floor(Math.random() * 360) + 'deg');
      rain.appendChild(piece);
    }
    document.body.appendChild(rain);
    setTimeout(function () { if (rain.parentNode) rain.parentNode.removeChild(rain); }, 4500);
  }

  function toast() {
    var prev = document.querySelector('.tcg-egg-toast');
    if (prev) prev.remove();
    var t = document.createElement('div');
    t.className = 'tcg-egg-toast';
    t.setAttribute('role', 'status');
    var msg = cfg.message || '¡Has invocado un secreto del Rincón!';
    var html = '<p class="tcg-egg-toast__msg">' + esc(msg) + '</p>';
    if (cfg.code) {
      html += '<div class="tcg-egg-toast__code"><code>' + esc(cfg.code) + '</code>' +
        '<button type="button" class="tcg-egg-toast__copy">Copiar</button></div>';
    }
    html += '<button type="button" class="tcg-egg-toast__close" aria-label="Cerrar">×</button>';
    t.innerHTML = html;
    document.body.appendChild(t);
    var copyBtn = t.querySelector('.tcg-egg-toast__copy');
    if (copyBtn) copyBtn.addEventListener('click', function () { copyText(cfg.code, copyBtn); });
    t.querySelector('.tcg-egg-toast__close').addEventListener('click', function () { t.remove(); });
    setTimeout(function () { if (t.parentNode) t.remove(); }, 20000);
  }

  function egg() {
    if (!armed) return;
    armed = false;
    document.documentElement.classList.add('tcg-egg-active');
    setTimeout(function () { document.documentElement.classList.remove('tcg-egg-active'); }, 2600);
    confetti();
    toast();
    setTimeout(function () { armed = true; }, 30000);
  }

  // ── Código Konami ─────────────────────────────────────────
  if (cfg.enabled) {
    document.addEventListener('keydown', function (e) {
      if (e.target && /^(input|textarea|select)$/i.test(e.target.tagName)) return;
      buffer.push(String(e.key).toLowerCase());
      if (buffer.length > SEQ.length) buffer.shift();
      if (buffer.join(',') === SEQ.join(',')) {
        buffer = [];
        egg();
      }
    });
  }

  // ── Mascota interactiva ───────────────────────────────────
  if (cfg.mascot) {
    var REACTS = ['tcg-react-wiggle', 'tcg-react-jump', 'tcg-react-spin'];
    var taps = [];
    document.addEventListener('click', function (e) {
      var m = e.target.closest ? e.target.closest('[data-tcg-mascot]') : null;
      if (!m) return;
      if (!reduceMotion) {
        REACTS.forEach(function (c) { m.classList.remove(c); });
        void m.offsetWidth; // reinicia la animación
        m.classList.add(REACTS[Math.floor(Math.random() * REACTS.length)]);
      }
      if (cfg.enabled) {
        var now = Date.now();
        taps.push(now);
        taps = taps.filter(function (t) { return now - t < 10000; });
        if (taps.length >= 7) {
          taps = [];
          egg();
        }
      }
    });
  }
})();
